<template>
  <ModalBase>
    <template #icon>
      <slot name="icon">
        <div
          class="bg-blue-50 w-10 h-10 flex justify-center items-center rounded-full ring-4 ring-blue-50/50"
        >
          <InformationCircleIcon class="w-5 h-5 text-blue-300" />
        </div>
      </slot>
    </template>
    <template #introText>
      <slot name="introText"></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
  </ModalBase>
</template>

<script setup>
import ModalBase from "./ModalBase.vue"
import { InformationCircleIcon } from "@heroicons/vue/20/solid"
</script>
